import { Button } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import Papa from "papaparse";
import importIcon from "../../assets/icons/import-icon.svg";
import exportIcon from "../../assets/icons/export-icon.svg";
import addingIcon from "../../assets/icons/adding-icon.svg";
import infomationIcon from "../../assets/icons/infomation_icon.svg";
import { toast } from "react-toastify";
import { Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { useCallback, useEffect, useRef, useState } from "react";
import { saveAs } from "file-saver";
import {
  getMappingItems,
  MappingItem,
  MappingItemPayload,
  updateMappingItem,
  createMappingItem,
  deleteMappingItem,
  importMappingItem,
} from "../../api-service/terminal-emp-mapping";

const CSV_HEADERS = ['DeviceId', 'EmpCode'];

const TerminalMapping = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDelDialogOpen, setIsDelDialogOpen] = useState(false);
  const [isDataExist, setIsDataExist] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [duplicateField, setDuplicateField] = useState<{ DeviceId: boolean; EmpCode: boolean }>({
    DeviceId: false,
    EmpCode: false,
  });

  const [terminalMappingData, setTerminalMappingData] = useState<MappingItem[]>(
    [],
  );

  const [selectedMappingItem, setSelectedMappingItem] = useState<{
    DeviceId: string | null
    EmpCode: string | null
    Id: string | null
  }>({
    DeviceId: null,
    EmpCode: null,
    Id: null,
  })

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    try {
      setIsLoading(true);
      const data: MappingItem[] = await getMappingItems();
      setTerminalMappingData(data);
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirmDelMapping = async () => {
    const idToFind = selectedMappingItem.Id;
    console.log(JSON.stringify(idToFind));
    setIsLoading(true);
    if (!idToFind) return;
    try {
      await deleteMappingItem(idToFind);
      setTerminalMappingData((prevData) => {
        return prevData.filter((item) => {
          return item.Id !== idToFind;
        });
      });
      setIsDelDialogOpen(false);
      setIsModalOpen(false);
      toast.success("解除しました。");
    } catch (error: any) {
      toast.error(`Deleted failed: ${error.message || "Unknow error"}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseDelMappingDialog = async () => {
    setIsDelDialogOpen(false);
  };

  const handleOpenDetailModal = ({ DeviceId, EmpCode, Id }) => {
    setDuplicateField({
      DeviceId: false,
      EmpCode: false,
    })
    setSelectedMappingItem({
      DeviceId: DeviceId,
      EmpCode: EmpCode,
      Id: Id,
    });
    setIsModalOpen(true);
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setSelectedMappingItem((prev) => {
      const newState = {
        ...prev,
        [name]: value.trim(),
      };
      return newState;
    });
  };

  const handleCheckDuplicateFields =  async (itemToSave: { DeviceId: string; EmpCode: string; Id: string | null }) => {
    let hasDuplicate = false;
  
    const hasDuplicateDevice = terminalMappingData.some(
      (item) =>
        item.DeviceId === itemToSave.DeviceId && item.Id !== itemToSave.Id
    );
  
    setDuplicateField({
      DeviceId: hasDuplicateDevice,
      EmpCode: false,
    });
  
    if (hasDuplicateDevice) {
      hasDuplicate = true;
    }
  
    return hasDuplicate;
  };

  const handleUpdateMappingItem = async () => {
    const deviceId = selectedMappingItem.DeviceId?.trim() || "";
    const empCode = selectedMappingItem.EmpCode?.trim() || "";
  
    setDuplicateField({ DeviceId: false, EmpCode: false });
  
    if (!deviceId || !empCode) {
      const newErrors = {
        DeviceId: !deviceId,
        EmpCode: !empCode,
      }
      setDuplicateField(newErrors);
    
      if (!deviceId) toast.error(" 端末IDをを入力してください。");
      if (!empCode) toast.error("社員コードを入力してください。");
      return;
    }
 
    setIsLoading(true);
    const itemToSave = {
      DeviceId: deviceId ?? "",
      EmpCode: empCode ?? "",
      Id: selectedMappingItem.Id ?? "",
    };
    const isUpdate = !!itemToSave.Id;

    try {
      const isDuplicate = await handleCheckDuplicateFields(itemToSave);
      if (isDuplicate) return;
      let apiResponse: any;
      let successMessage: any;

      if (isUpdate) {
        apiResponse = await updateMappingItem(itemToSave);
        successMessage = "更新しました。";
      } else {
        apiResponse = await createMappingItem(itemToSave);
        successMessage = "登録しました。";
      }

      setTerminalMappingData((prevData) => {
        if (isUpdate) {
          return prevData.map((item) => {
            if (item.Id === itemToSave.Id) {
              return apiResponse;
            }
            return item;
          });
        } else {
          return [ ...prevData, apiResponse];
        }
      });

      setIsModalOpen(false);
      toast.success(successMessage);
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFileChange = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (file) {
        setIsLoading(true);
        const reader = new FileReader();
        reader.onload = () => {
          const csvText = reader.result as string;
          Papa.parse(csvText, {
            header: true,
            skipEmptyLines: true,
            complete: async (results: any) => {
              // check header
              const headers = (results.meta.fields || []).map((field: string) => field.trim().replace(/^\uFEFF/, ""));
              const isValidHeader = headers.length === CSV_HEADERS.length &&
                CSV_HEADERS.every((header, index) => headers[index] === header);
              if (!isValidHeader) {
                toast.error('CSVヘッダーの形式が正しくありません。再度ご確認ください。');
                setIsLoading(false);
                return;
              }
              // processing data
              const rawData = results.data.map((row: any) => {
                const cleaned: any = {};
                Object.keys(row).forEach((key) => {
                  const cleanKey = key.trim();
                  const cleanValue =
                    typeof row[key] === "string" ? row[key].trim() : row[key];
                  cleaned[cleanKey] = cleanValue;
                });
                return cleaned;
              });
              try {
                const importBody = {
                  items: rawData,
                };
                const apiResponse = await importMappingItem(importBody);
                if (apiResponse) {
                  fetchItems();
                  toast.success("完了しました。");
                }
              } catch (error: any) {
                toast.error("アップロードに失敗しました。再度お試しください。");
              } finally {
                setIsLoading(false);
              }
            },
            error: (error: any) => {
              toast.error(error.message);
              setIsLoading(false);
            },
          });
        };
        reader.readAsText(file);
        e.target.value = "";
      }
    },
    [],
  );

  const handleUploadFile = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleExportData = async () => {
    if (!terminalMappingData || terminalMappingData.length === 0) {
      toast.error("ダウンロードに失敗しました。再度お試しください。");
      return;
    }
    try {
      const dataToExport = terminalMappingData.map((item) => ({
        DeviceId: item.DeviceId,
        EmpCode: item.EmpCode,
        // CreatedDate: item.CreatedDate,
        // OrgId: item.OrgId,
      }));
      const csv = Papa.unparse(dataToExport);
      const csvWithBom = "\uFEFF" + csv;
      const blob = new Blob([csvWithBom], { type: "text/csv;charset=utf-8;" });
      const date = new Date().toISOString().slice(0, 10).replace(/-/g, "");
      const fileName = `TerminalEmployeeMapping-${date}.csv`;
      saveAs(blob, fileName);
    } catch (error) {
      toast.error("ダウンロードに失敗しました。再度お試しください。");
    }
  };

  return (
    <>
      {isLoading && (
        <div className="provider-loading">
          <Spinner variant="light" />
        </div>
      )}
      <div className="d-flex">
        <div className="data-operation-container">
          <span>1.CSVファイルをダウンロード</span>
          <Button
            color="primary"
            variant="outlined"
            className="bg-white import-btn data-action-btn"
            size="medium"
            fullWidth={false}
            onClick={handleExportData}
            disabled={!terminalMappingData || terminalMappingData.length === 0}
          >
            <img src={importIcon} alt="" /> 一括ダウンロード
          </Button>
        </div>
        <div className="data-operation-container">
          <span>2.編集したファイルを反映</span>
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          <Button
            color="primary"
            variant="outlined"
            className="bg-white data-action-btn"
            size="medium"
            onClick={handleUploadFile}
          >
            <img src={exportIcon} alt="" /> ファイルをアップロード
          </Button>
        </div>
      </div>

      {/* Terminal employee mapping container */}
      <div className="terminal-table-setting bg-white">
        <div className="d-flex terminal-table-setting_header">
          <Button
            variant="contained"
            className="terminal-adding-btn"
            onClick={() => {
              setIsDataExist(false);
              handleOpenDetailModal({
                DeviceId: null,
                EmpCode: null,
                Id: null,
              });
            }}
          >
            <img src={addingIcon} alt="" /> 新規追加
          </Button>
          <span className="ms-auto total-item">
            {terminalMappingData.length}件
          </span>
        </div>

        <TableContainer
          component={Paper}
          className="terminal-mapping-table"
          sx={{
            maxHeight: "55vh",
            overflowY: "auto",
            boxShadow:
              "0px 1px 0px 0px rgba(201, 201, 201, 0.5), " +
              "0px 1px 0px 0px rgba(201, 201, 201, 0.35), " +
              "0px 1px 1px 0px rgba(201, 201, 201, 0.15)",
          }}
        >
          <Table
            stickyHeader
            className=""
            sx={{ tableLayout: "fixed", width: "100%" }}
          >
            <TableHead className="table_thead">
              <TableRow>
                <TableCell
                  className="bg-light_thead"
                  sx={{
                    width: "40%",
                    borderTopLeftRadius: "4px",
                    fontSize: "13px",
                    borderBottom: "none",
                  }}
                >
                  端末ID
                </TableCell>
                <TableCell
                  className="bg-light_thead"
                  sx={{ width: "30%", fontSize: "13px", borderBottom: "none" }}
                >
                  社員コード
                </TableCell>
                <TableCell
                  className="bg-light_thead"
                  sx={{
                    width: "30%",
                    textAlign: "right",
                    borderTopRightRadius: "4px",
                    borderBottom: "none",
                  }}
                ></TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="terminal-mapping-table_content">
              {terminalMappingData.map((item) => (
                <TableRow
                  key={item.DeviceId}
                  className="terminal-mapping-row"
                  hover
                  sx={{
                    "&:hover": {
                      backgroundColor: "#f0f0f0 !important",
                    },
                  }}
                >
                  <TableCell
                    className="border-bottom_"
                    sx={{ width: "40%", fontSize: 13, wordWrap: "break-word" }}
                  >
                    <span>{item.DeviceId}</span>
                  </TableCell>
                  <TableCell
                    className="border-bottom_"
                    sx={{ width: "30%", fontSize: 13, wordWrap: "break-word" }}
                  >
                    <span>{item.EmpCode}</span>
                  </TableCell>
                  <TableCell
                    className="border-bottom_ text-end"
                    sx={{ width: "30%", textAlign: "right" }}
                  >
                    <Button
                      size="small"
                      variant="outlined"
                      className="ter-btn"
                      onClick={() => {
                        setIsDataExist(true);
                        handleOpenDetailModal(item);
                      }}
                    >
                      編集
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <Modal
        className="storage-cmp delete-confirm-dialog"
        show={isDelDialogOpen}
        centered
        onHide={() => {
          setIsDelDialogOpen(false);
        }}
      >
        <Modal.Header closeButton>
          <img
            src={infomationIcon}
            alt="info"
            className="me-1"
            style={{ order: 0 }}
          />
          確認
        </Modal.Header>
        <Modal.Body>
          端末社員マッピングを削除します。
          <br />
          よろしいですか？
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <div className="dialog-btn-footer">
            <Button
              size="small"
              className="dialog-btn modal-cancel-btn bg-white"
              onClick={handleCloseDelMappingDialog}
            >
              キャンセル
            </Button>
            <Button
              size="small"
              className="dialog-btn dialog-del-confirm"
              onClick={handleConfirmDelMapping}
            >
              保存
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal
        className="terminal-mapping-modal"
        centered
        show={isModalOpen}
        onHide={() => setIsModalOpen(false)}
        size="lg"
        animation={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <span className="terminal-mapping-modal_title">
              {!isDataExist
                ? "端末社員マッピング新規作成"
                : "端末社員マッピング編集"}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm="2">
                端末ID
              </Form.Label>
              <Col sm="5">
                <Form.Control
                  name="DeviceId"
                  type="text"
                  value={selectedMappingItem?.DeviceId || ""}
                  onChange={handleInputChange}
                  isInvalid={duplicateField.DeviceId}
                />
                <Form.Control.Feedback type="invalid">
                  {!selectedMappingItem?.DeviceId?.trim()
                    ? "端末IDをを入力してください。"
                    : "入力された端末IDは既に登録されています。"}
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm="2">
                社員コード
              </Form.Label>
              <Col sm="5">
                <Form.Control
                  type="text"
                  name="EmpCode"
                  value={selectedMappingItem?.EmpCode || ""}
                  onChange={handleInputChange}
                  isInvalid={duplicateField.EmpCode}
                />
                <Form.Control.Feedback type="invalid">
                  社員コードを入力してください。
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <div>
            {isDataExist && (
              <>
                <Button
                  size="small"
                  className="bg-white terminal-delete-btn"
                  variant="outlined"
                  onClick={() => setIsDelDialogOpen(true)}
                >
                  削除
                </Button>
              </>
            )}
          </div>

          <div className="modal-footer-flex-btn">
            <Button
              size="small"
              className="bg-white terminal-cancel-btn"
              variant="outlined"
              onClick={() => setIsModalOpen(false)}
            >
              キャンセル
            </Button>
            <Button
              size="small"
              className="modal-btn terminal-save-btn"
              variant="outlined"
              onClick={handleUpdateMappingItem}
            >
              保存
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TerminalMapping;
